export const MARKETING_ACTION_SELECTOR_TRANSLATION_NAMESPACE = "marketing-action-selector";

export const MARKETING_ACTIONS_CREATE_VIEW_TK = "MARKETING_ACTIONS_SELECTOR_TK";
